// BUILD-042 — Unified employee workspace, My HR (self). "Onboarding & Offboarding" destination.
// GET /hr/me/checklists (getMyHrChecklists) and ChecklistAssignmentsPanel both ALREADY EXIST
// and are already used by HR Administration's own Checklists tab — this file only wires the
// existing self-scope endpoint to the existing shared panel for the Employee's OWN assignments,
// a connection that previously had no caller anywhere in My HR. This is reuse of existing
// capability, not new backend work (decision: "reuse existing... where possible").
// Status updates remain self-scope-authorized server-side exactly as before; this view does not
// change authorization, only exposes it where My HR's nav had no destination for it yet.
import { useEffect, useState } from 'react';
import { getMyHrChecklists, type HrChecklistAssignment } from '../../../api/client';
import { ChecklistAssignmentsPanel } from '../ChecklistAssignmentsPanel';
import { CardTitle } from './SectionHeading';

export function OnboardingSelfSection({ focusTaskId }: { focusTaskId?: string | null } = {}) {
  const [assignments, setAssignments] = useState<HrChecklistAssignment[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  function refresh() {
    getMyHrChecklists()
      .then((d) => { setAssignments(d.assignments); setError(null); })
      .catch((e: any) => setError(e.message || 'Could not load your checklists.'));
  }
  useEffect(() => { refresh(); }, []);

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
      <CardTitle>Your checklists</CardTitle>
      {error ? (
        <div className="text-sm text-red-700">{error}</div>
      ) : assignments === null ? (
        <div className="text-sm text-gray-400">Loading…</div>
      ) : (
        <ChecklistAssignmentsPanel assignments={assignments} onChanged={refresh} focusTaskId={focusTaskId} />
      )}
    </div>
  );
}
